/* ========================================
   TRACK ORDER PAGE — JS
   ======================================== */
(function () {
  'use strict';

  /* ---------- Tab Switcher ---------- */
  var tabs = document.querySelectorAll('.track-tabs__tab');
  var panels = document.querySelectorAll('.track-form__panel');

  function switchTab(selectedTab) {
    tabs.forEach(function (tab) {
      var isSelected = tab === selectedTab;
      tab.classList.toggle('active', isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
    });
    panels.forEach(function (panel) {
      var targetId = selectedTab.getAttribute('aria-controls');
      if (panel.id === targetId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      switchTab(tab);
    });

    tab.addEventListener('keydown', function (e) {
      var idx = Array.from(tabs).indexOf(tab);
      var newIdx = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIdx = (idx + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIdx = (idx - 1 + tabs.length) % tabs.length;
      }
      if (newIdx >= 0) {
        tabs[newIdx].focus();
        switchTab(tabs[newIdx]);
      }
    });
  });

  /* ---------- Form Submission ---------- */
  var formOrder = document.getElementById('track-form-order');
  var formEmail = document.getElementById('track-form-email');

  function validateOrderNumber(value) {
    var trimmed = value.trim();
    return trimmed.length >= 3;
  }

  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function clearErrors() {
    document.querySelectorAll('.track-form__group--error').forEach(function (g) {
      g.classList.remove('track-form__group--error');
    });
    document.querySelectorAll('.form-error').forEach(function (e) {
      e.setAttribute('hidden', '');
    });
  }

  function showError(groupEl, errorEl) {
    groupEl.classList.add('track-form__group--error');
    errorEl.removeAttribute('hidden');
  }

  /* Redirect to Shopify account/orders page */
  function goToOrders() {
    window.location.href = '/account';
  }

  if (formOrder) {
    formOrder.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();

      var input = document.getElementById('track-order-number');
      var group = input.closest('.track-form__group');
      var error = document.getElementById('track-order-error');

      if (!validateOrderNumber(input.value)) {
        showError(group, error);
        input.focus();
        return;
      }

      goToOrders();
    });
  }

  if (formEmail) {
    formEmail.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();

      var input = document.getElementById('track-email-input');
      var group = input.closest('.track-form__group');
      var error = document.getElementById('track-email-error');

      if (!validateEmail(input.value)) {
        showError(group, error);
        input.focus();
        return;
      }

      goToOrders();
    });
  }

  /* Clear error state on input */
  document.querySelectorAll('.track-form__input').forEach(function (input) {
    input.addEventListener('input', function () {
      var group = input.closest('.track-form__group');
      if (group && group.classList.contains('track-form__group--error')) {
        group.classList.remove('track-form__group--error');
        var err = group.querySelector('.form-error');
        if (err) err.setAttribute('hidden', '');
      }
    });
  });

})();
